import { render } from "./ViewportBackground.vue?vue&type=template&id=a9ca1b50&scoped=true&ts=true"
import script from "./ViewportBackground.vue?vue&type=script&lang=ts"
export * from "./ViewportBackground.vue?vue&type=script&lang=ts"

import "./ViewportBackground.vue?vue&type=style&index=0&id=a9ca1b50&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9ca1b50"]])

export default __exports__